<template>
  <div class="reward contents">
    <div
      class="rewardView"
    >
      <div class="info">
        <h1>{{monthText}}</h1>
        <p>{{reward.targetMonthReward}}</p>
        <dl>
          <dt>지급일</dt>
          <dd>{{paymentDay}}</dd>
        </dl>
        <router-link class="btPrev" :to="toPath(prevYearMonth)"><span class="accessibilityHide">이전달</span></router-link>
        <router-link class="btNext" :class="{'disabled': !nextYearMonth}" :to="toPath(nextYearMonth)"><span class="accessibilityHide">다음달</span></router-link>
      </div>
      <div class="detail">
        <dl>
          <dt class="accessibilityHide">기간</dt>
          <dd>{{period}}</dd>
        </dl>
        <dl>
          <dt>조회수</dt>
          <dd>{{reward.viewCount}}</dd>
        </dl>
        <dl>
          <dt>구매 상품수</dt>
          <dd>{{reward.purchaseProductCount}}</dd>
        </dl>
        <dl>
          <dt>구매 완료 금액</dt>
          <dd>{{reward.purchaseProductPrice}}</dd>
        </dl>
        <dl>
          <dt>쿠폰 사용 금액</dt>
          <dd>{{reward.usedProductPrice}}</dd>
        </dl>
        <dl>
          <dt>리워드 적립 금액 </dt>
          <dd>{{reward.targetMonthReward}}</dd>
        </dl>
      </div>
    </div>
    <div class="rewardInfo">
      <h3>포인트 적립 유의 사항</h3>
      <ul>
        <li>오늘 사용된 쿠폰은 다음날 오전 7시 이후에 쿠폰 사용 금액에 반영됩니다.</li>
        <li>리워드 적립 금액은 쿠폰 사용 금액의 기본 {{rewardValue}}%, 월 최대 {{maxRewardPerMonth}}원이 적립됩니다.<br>(상품에 따라 적립 금액은 다를 수 있으며, 상품별 적립율은 상품 상세페이지의 공유하기에서 확인해주세요.)</li>
        <li>리워드 포인트 적립으로 지정된 상품에 대해서만 포인트 지급됩니다.</li>
        <li>이번달 적립된 금액은 다음달 15일 플레이포인트로 지급됩니다. </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MyAPI from '@/api/my'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  components: {
  },
  props: {
    rewardYearMonth: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      reward: {}
    }
  },
  watch: {
    rewardYearMonth: {
      handler(n, o) {
        if (n) {
           this.reward = {}
           this.callAPI(n)
        }
      }
    }
  },
  computed: {
    ...mapGetters('main', ['rewardValue', 'maxRewardPerMonth']),
    nowYearMonth() {
      const now = new Date(),
        year = now.getFullYear(),
        month = now.getMonth() + 1
      return Number(`${year}${this.addZero(month)}`)
    },
    prevYearMonth() {
      let year = Number(this.year),
        month = this.numMonth - 1
      if (month === 0) {
        month = 12
        year--
      }
      return `${String(year)}${this.addZero(month)}`
    },
    nextYearMonth() {
      let yearMonth,
        year = Number(this.year),
        month = this.numMonth + 1
      if (month > 12) {
        month = 1
        year++
      }
      yearMonth = `${String(year)}${this.addZero(month)}`
      if (this.rewardYearMonth < this.nowYearMonth) {
        return yearMonth
      } else {
        return false
      }
    },
    year() {
      return String(this.rewardYearMonth).substr(0, 4)
    },
    month() {
      return String(this.rewardYearMonth).substr(4, 2)
    },
    numMonth() {
      return Number(this.month)
    },
    monthText() {
      return `${(this.rewardYearMonth === this.nowYearMonth) ? '이번달' : this.numMonth + '월'} 적립 플레이포인트`
    },
    paymentDay() {
      return `${(this.numMonth === 12) ? 1 : this.numMonth + 1}월 15일`
    },
    lastDay() {
      if (this.rewardYearMonth === this.nowYearMonth) {
        return new Date().getDate() - 1
      } else {
        return new Date(this.year, this.month, 0).getDate()
      }
    },
    period() {
      return `${this.year}.${this.month}.01 - ${this.month}.${this.lastDay}`
    },
  },
  methods: {
    callAPI(rewardYearMonth) {
      MyAPI.getRewardDetail(rewardYearMonth, responseData => {
        // this.reward = responseData.data
        this.reward = {
          "viewCount": responseData.data.viewCount,
          "targetMonthReward": responseData.data.targetMonthReward.addComma(),
          "purchaseProductCount": responseData.data.purchaseProductCount.addComma(),
          "purchaseProductPrice": responseData.data.purchaseProductPrice.addComma(),
          "usedProductPrice": responseData.data.usedProductPrice.addComma() 
        }
      })
    },
    addZero(val) {
      return String((val < 10) ? '0' + val : val)
    },
    toPath(val) {
      if (val) {
        return { name: `${this.$route.name}`, params: { rewardYearMonth: `${val}` }}
      } else {
        return {}
      }
    },
  },
  mounted() {
    if (this.rewardYearMonth > this.nowYearMonth || String(this.rewardYearMonth).length !== 6) {
      this.$router.replace({ name: 'reward' })
    }
    this.callAPI(this.rewardYearMonth)
  },
}
</script>

<style lang="scss">
.reward {
  .info {
    position: relative;
    height: 134px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;
    text-align: center;
    h1 {
      padding-top: 21px;
      margin: 0;
      font-size: 14px;
      line-height: 1.14;
      color: #151721;
    }
    p {
      padding-top: 26px;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.15;
      color: #6134f1;
      &::before {
        content: "";
        display: inline-block;
        width: 21px;
        height: 21px;
        margin: 0 3px -3px 0;
        background: url("~@/assets/images/set_reward.svg") no-repeat -25px -75px;
        background-size: 53px auto;
      }
    }
    dl {
      padding-top: 9px;
      font-size: 13px;
      line-height: 1.15;
      color: #151721;
    }
    dt,
    dd {
      display: inline;
    }
    dt {
      padding-right: 5px;
      &::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 11px;
        margin: 0 0 -1px 5px;
        background-color: #8d92a8;
      }
    }
    a {
      position: absolute;
      top: 10px;
      left: 50%;
      display: block;
      width: 30px;
      height: 37px;
      background: url("~@/assets/images/set_icon.png") no-repeat 0 0;
      background-size: 100px auto;
      &.btPrev {
        margin-left: -117px;
        background-position: 10px -1140px;
      }
      &.btNext {
        margin-left: 87px;
        background-position: -40px -1140px;
      }
      &.disabled {
        opacity: 0.34;
        cursor: default;
      }
    }
  }
  .detail {
    margin-top: 10px;
    border-bottom: 1px solid #efefef;
    background-color: #fff;
    dl {
      height: 29px;
      padding: 15px 0 0 0;
      margin: 0 16px;
      font-size: 13px;
      line-height: 1.15;
      color: #636376;
      dt {
        display: inline-block;
        font-size: 13px;
        width: 40%;
      }
      dd {
        display: inline-block;
        font-size: 15px;
        width: 60%;
        text-align: right;
      }
      &:nth-child(1) {
        height: 31px;
        padding: 7px 0 0 16px;
        margin: 0;
        font-weight: bold;
        line-height: 1.18;
        color: #151721;
        border-bottom: 1px solid #d6d6e0;
        dd {
          width: 100%;
          font-size: 11px;
          text-align: left;
        }
      }
      &:nth-child(2),
      &:nth-child(4) {
        height: 49px;
        border-bottom: 1px solid #636376;
      }
      &:last-child {
        height: 47px;
      }
    }
  }
}
</style>
